import { roles } from '@/config/roles'

const routes = [
  {
    name: 'StudentsList',
    path: '/student/list',
    component: () => import('@/views/students/index.vue'),
    meta: {
      roles: [roles.curator]
    }
  },
  {
    path: '/student/list/:id',
    name: 'StudentProfile',
    component: () => import('@/views/students/Profile.vue'),
    meta: {
      roles: [roles.teacher, roles.curator, roles.admin]
    }
  }
]
export default routes
